/*
 * TASK POPUP LAYOUT
 *
 * Provides the shared primary-and-details composition for task forms.
 *
 * Recent changes:
 * - Delegates to the feature-neutral popup grid so task and note dialogs stay aligned.
 */

import { ComponentProps } from 'react';
import ResponsivePopupLayout from '../../popup/ResponsivePopupLayout';

type TaskPopupLayoutProps = Omit<ComponentProps<typeof ResponsivePopupLayout>, 'testId'>;

export default function TaskPopupLayout({
  primary,
  details,
  stacked = false,
  className = '',
}: TaskPopupLayoutProps) {
  return <ResponsivePopupLayout primary={primary} details={details} stacked={stacked} className={className} testId="task-popup-layout" />;
}
